module.exports = __webpack_public_path__ + "img/Flag_of_Seychelles.1da3303b.svg";